import styledComponents from 'styled-components'
import { SHADOWS } from 'tokens'

const styled = styledComponents

export const Wrapper = styled.div`
  height: 851px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const Card = styled.div`
  width: 420px;
  height: 100%;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding: 24px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`

export const Header = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
  }

  p {
    margin: 2px 0;
    font-size: 14px;
    color: #666;
  }
`

export const Avatar = styled.img`
  width: 88px;
  height: 88px;
  border-radius: 8px;
  object-fit: cover;
`

export const NameText = styled.span`
  color: var(--color-text-primary);
  font-size: 20px;
  font-weight: 800;
  margin-right: 132px;
  width: 100%;
  text-transform: capitalize;
`
export const LastNameText = styled.span`
  color: var(--color-text-primary);
  font-size: 20px;
  font-weight: 800;
  margin-top: -6px;
  width: 100%;
  text-transform: capitalize;
`

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const StatsCard = styled.div`
  border: 1px solid var(--color-border-primary);
  border-radius: 6px;
  padding: 16px;
  margin-top: 10px;
`

// ✨ PERFECT COLUMN ALIGNMENT ✨
export const StatRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  padding: 10px 16px;
  align-items: center;
  font-size: 14px;
`

export const ColLabel = styled.div`
  font-weight: 500;
  color: #333;
`

export const ColValueMain = styled.div`
  text-align: right;
  font-weight: 600;
`

export const ColValuePrev = styled.div`
  text-align: right;
  font-size: 13px;
`

export const FooterActions = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 12px;
`

export const ButtonPrimary = styled.div<{ $disabled?: boolean }>`
  padding: 12px;
  border: 1px solid ${(props) => (props.$disabled ? 'var(--color-disabled)' : 'var(--color-border-primary)')};
  background: ${(props) => (props.$disabled ? 'var(--color-disabled-bg)' : 'var(--color-bg)')};
  border-radius: 6px;
  box-shadow: ${SHADOWS.boxShadow};
  font-size: 16px;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.$disabled ? 'var(--color-disabled)' : 'inherit')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};
`

export const LogoutButton = styled.div`
  padding: 12px;
  background: #f44336;
  color: var(--color-text-secondary);
  font-weight: 700;
  box-shadow: ${SHADOWS.boxShadow};
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`
